export default document
